import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Avatar } from '@sravni/react-design-system';
import modules_c7892e2f from './CardIcon.module.scss.js';

/** Компонент для отрисовки логотипа карточки */
var CardIcon = function (_a) {
    var _b;
    var src = _a.src, _c = _a.size, size = _c === void 0 ? 'l' : _c, transparent = _a.transparent;
    return jsx(Avatar, { size: 44, src: src, className: cn(modules_c7892e2f.root, (_b = {},
            _b[modules_c7892e2f.transparent] = transparent,
            _b[modules_c7892e2f['size-s']] = size === 's',
            _b[modules_c7892e2f['size-m']] = size === 'm',
            _b[modules_c7892e2f['size-l']] = size === 'l',
            _b)) });
};

export { CardIcon };
//# sourceMappingURL=CardIcon.js.map
